import { useState } from "react";
import { IoIosSend } from "react-icons/io";
import http from "../services/http";
import config from "../config/api.json";
import { toast } from "react-toastify";

const Contact = (props) => {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");

  const formatPhoneNumber = (value) => {
    // Remove all non-numeric characters
    const cleaned = value.replace(/\D/g, "");

    // Format based on the length of the input
    if (cleaned.length <= 3) {
      return cleaned; // (###)
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`; // (###) ###
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
        6,
        10
      )}`; // (###) ###-####
    }
  };

  const handleChange = (e) => {
    const input = e.target.value;
    const formatted = formatPhoneNumber(input);
    setPhoneNumber(formatted);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setButtonDisabled(true);

      const reqBody = {
        name,
        email,
        phone: phoneNumber,
        message,
      };

      const url = `${config.apiUrl}/contact`;

      await http.post(url, reqBody);

      setName("");
      setEmail("");
      setPhoneNumber("");
      setMessage("");

      toast.success("Submission successful. Thank you!");
      setButtonDisabled(false);
    } catch (err) {
      if (err.response) {
        toast.error(err.response.data.message);
        setButtonDisabled(false);
      } else {
        toast.error("Unexpected error. Please try again.");
        setButtonDisabled(false);
      }
    }
  };

  return (
    <div className="contactcontainer">
      <div className="scrollcontrol" id="contact" />
      <div className="contactform">
        <h1>Contact</h1>
        <p>Name</p>
        <input
          type="text"
          className="name"
          placeholder="Name..."
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <p>Email</p>
        <input
          type="email"
          className="email"
          placeholder="Email..."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <p>Phone</p>
        <input
          type="text"
          id="phone"
          value={phoneNumber}
          onChange={handleChange}
          placeholder="(123) 456-7890"
          maxLength={14} // Max length for (###) ###-####
        />
        <p>Message</p>
        <textarea
          name=""
          id=""
          cols="30"
          rows="10"
          placeholder="Messsage..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
        <button disabled={buttonDisabled} onClick={handleSubmit}>
          <IoIosSend />
          Send
        </button>
      </div>
    </div>
  );
};

export default Contact;
